import { Button } from 'components';
import { useFormikContext } from 'formik';
import { useIsOnlyVisibleToUserWithPermissions } from 'utils/hooks/useIsOnlyVisibleTo';
import { PERMISSION } from 'utils/protectedRoutes/userRolesAndPermissionTypes';

import { useIsTranscribing } from '../hooks/useIsTranscribing';
import { NoteFormValues } from '../utils/validation';
import style from '../noteEdit.module.scss';

type EditButtonProps = {
  onClick?: () => void;
  className?: string;
};

export const EditButton = ({ onClick, className }: EditButtonProps) => {
  const formik = useFormikContext<NoteFormValues>();
  const isTranscribing = useIsTranscribing();
  const canUpdateManagerReview = useIsOnlyVisibleToUserWithPermissions([
    PERMISSION.UPDATE_MANAGER_REVIEW
  ]);

  const isDisabled =
    isTranscribing || (!canUpdateManagerReview && formik.values.noteType === 'MANAGER_REVIEW');

  return (
    <Button
      customStyleClass={className || style.actionButton}
      theme="transparent"
      type="button"
      text=""
      icon={<span className="material-icons">edit</span>}
      handleOnClick={onClick}
      disabled={isDisabled}
    />
  );
};
